import { useCapabilityValue } from '../../store/devices/useCapabilityValue';

import styles from './IndicatorString.module.css';

export function IndicatorString(props) {
  const [value] = useCapabilityValue({
    deviceId: props.device.id,
    capabilityId: props.capabilityId,
  });

  return (
    <div className={styles.root} title={typeof value === 'string' ? value : undefined}>
      {value}
    </div>
  );
}
